export default "__VITE_ASSET__Bdgjv7sa__"